import React from "react";
import {useMatch} from "@tanstack/react-location";
import CredentialsCard from "../../../../components/DeviceDetails/credentialsCard";

const Credentials = () => {
  const {
    params: {cloudInstanceId},
  } = useMatch();

  return <CredentialsCard params={{cloud_instance_id: cloudInstanceId}} />;
};

export default Credentials;
